export default {
  title: 'DIY Modeler',
  subtitle: 'Modelos simples e genéricos que você pode criar de forma independente, com seus dados e nossa tecnologia.',
  createModel: 'Criar Modelo',
  cancel: 'Cancelar',
  wizardUploadHint: 'Clique no botão abaixo para enviar seus dados.',
  wizardDownloadTemplateText: 'Você pode baixar uma cópia do template de dados',
  wizardDownloadTemplateLink: 'aqui',
  unsupportedFileType: 'Tipo de arquivo nao suportado. Apenas arquivos .xlsx sao aceitos.',
  errorUploadingFile: 'Erro ao enviar o arquivo. Por favor tente novamente.',
  uploadingFile: 'Enviando arquivo',
  validationErrorsTitle: 'Erros de Validacao',
  sheetGeneral: 'Geral',
  errorSingular: 'erro',
  errorPlural: 'erros',
  close: 'Fechar',
  rows: 'linhas',
  andMore: 'E mais {count}',
  downloadCsv: 'Exportar Detalhes dos Erros como CSV',
  priorsMarketingTitle: 'Faixa de Atribuicao Total de Marketing',
  priorsMarketingDescription: 'Defina a faixa esperada para a contribuicao total de todas as atividades de marketing ao seu KPI.',
  priorsMin: 'Min',
  priorsMax: 'Max',
  priorsChannelTitle: 'Faixa de ROAS por Mídia',
  priorsChannelDescription: 'Habilite cada canal de mídia para o qual deseja definir uma faixa de ROAS alvo. Os canais desabilitados não terão restrições.',
  priorsNoChannels: 'Envie e valide um arquivo de dados para ver os canais de midia disponiveis.',
  priorsAdstockTitle: 'Midias de Decaimento Rapido',
  priorsAdstockDescription: 'Selecione todos os canais de midia cujos efeitos decaem rapidamente ao longo do tempo.',
  priorsNoChannelsAdstock: 'Envie e valide um arquivo de dados para ver os canais de midia disponiveis.',
  priorsSaturationTitle: 'Selecionar Restrição',
  priorsSaturationOptionAttribution: 'Faixa de Atribuição Total de Marketing',
  priorsSaturationOptionRoas: 'Faixa de ROAS por Mídia',
  priorsStepAttribution: 'Atribuição',
  priorsStepRoas: 'ROAS',
  priorsStepAttributionRoas: 'Restrições',
  priorsStepDecay: 'Decaimento Rápido',
  generateNameAlreadyUsed: 'Este nome ja esta em uso.',
  generateNameExistsInClients: 'Ja existe um modelo de cliente com este nome.',
  errorGeneratingModel: 'Erro ao gerar o modelo. Por favor tente novamente.',
  wizardTitle: 'Novo Modelo Automatico',
  wizardStepDataUpload: 'Carga de Dados',
  wizardModelNameLabel: 'Nome do Modelo',
  wizardSelectFile: 'Selecionar Arquivo de Dados',
  wizardReUpload: 'Reenviar Arquivo',
  wizardValidating: 'Validando seus dados...',
  wizardValidSuccess: 'Dados validados com sucesso',
  wizardValidFailed: 'A validacao falhou',
  wizardValidationIssuesIntro: 'Seu modelo de dados contém os seguintes problemas que devem ser resolvidos para continuar:',
  wizardViewErrors: 'Ver Erros',
  wizardStepModelName: 'Nome do Modelo',
  wizardModelNameDescription: 'Escolha um nome para o seu modelo. Este nome deve ser unico.',
  wizardGenerateButton: 'Gerar',
  wizardGenerating: 'Gerando...',
  headerModelName: 'Nome do Modelo',
  headerDateCreated: 'Criado',
  headerCreatedBy: 'Criado Por',
  headerDetails: 'Configurações',
  headerStatus: 'Status',
  detailsAttribution: 'Atribuição',
  detailsRoas: 'ROAS',
  detailsFastDecay: 'Dec. Rápido',
  detailsAttributionRange: 'Faixa de atribuição: {min}% – {max}%',
  detailsRoasChannels: 'Faixas de ROAS:',
  detailsFastDecayChannels: 'Canais de decaimento rápido:',
  statusPending: 'Pendente',
  statusUploaded: 'Enviado',
  statusGenerating: 'Gerando Modelo',
  statusGenerated: 'Gerado',
  statusError: 'Erro',
  deleteModel: 'Excluir Modelo',
  deleteWarningTitle: 'Excluir Modelo',
  deleteModelMessage: 'Tem certeza de que deseja excluir permanentemente "{name}"? Esta ação não pode ser desfeita.',
  deleteModelMessageTrash: 'Tem certeza de que deseja excluir "{name}"? Você poderá recuperá-lo durante 7 dias solicitando a um administrador.',
  deleteModelConfirm: 'Excluir',
  delete: 'Excluir',
  unnamedModel: 'Modelo Sem Nome',
  priorsMaxBelowMin: 'Max deve ser > Min',
  priorsValueMustBePositive: 'Deve ser > 0',
  priorsValueCannotBeNegative: 'Deve ser >= 0',
  priorsChannelMaxLimit: 'Deve ser <= 10',
  priorsValueOutOfRange: 'Deve estar entre 0 e 100',
  dataFrequencyLabel: 'Frequencia dos Dados',
  dataFrequencyDescription: 'Selecione a frequencia dos seus dados antes de enviar.',
  dataFrequencyWeekly: 'Semanal',
  dataFrequencyMonthly: 'Mensal',
  downloadDataTemplate: 'Baixar Modelo de Dados',
  downloadAssemblerPkl: 'Baixar Assembler PKL',
  printConfigMap: 'Imprimir Mapa de Configuração',
  printJson: 'Imprimir JSON',
  viewReport: 'Ver Relatório',
  highMapeWarning: 'A precisao do modelo pode ser baixa',
  modelNameNoteTitle: 'Nota',
  modelNameNoteText: 'Os graficos do Relatorio do Modelo exibem os ultimos 3 anos de dados. Suas restricoes de ROAS e Atribuicao sao aplicadas em todo o seu conjunto de dados, portanto os valores mostrados nos graficos podem estar fora dos intervalos especificados. Essas diferencas sao esperadas devido a esta abordagem.',
  wizardMediaChannelsDetected: 'Canais de midia detectados',
  wizardChannelOriginalName: 'Nome Original',
  wizardChannelDisplayName: 'Nome de Exibição'
}
